import { LuKeyRound } from 'react-icons/lu';
import { formatRelativeDate } from '@/utils/dateUtils.ts';
import { HStack, Text } from '@chakra-ui/react';
import React from 'react';

interface Props {
	expiresAt: string | null;
}

export const GuestAccessIndicator: React.FC<Props> = (props) => {
	const { expiresAt } = props;

	return (
		<HStack w="full" gap={2} justify="center">
			<LuKeyRound />
			<Text>{expiresAt ? `until ${formatRelativeDate(expiresAt)}` : 'Ongoing'}</Text>
		</HStack>
	);
};
